import React from 'react';
import { Card, Typography, List, ListItem, ListItemPrefix } from "@material-tailwind/react";
import { PresentationChartBarIcon, ShoppingBagIcon, UserCircleIcon, PowerIcon, HandRaisedIcon, ChartBarIcon } from "@heroicons/react/24/solid";

export function PatientSidebar({ onSidebarClick }) {
  return (
    <Card className="h-[calc(100vh-2rem)] w-full max-w-[20rem] p-4 shadow-xl shadow-blue-gray-900/5">
      <div className="mb-2 p-4">
        <Typography variant="h5" color="blue-gray">
          Dashboard
        </Typography>
      </div>
      <List>
        <ListItem onClick={() => onSidebarClick('request')}>
          <ListItemPrefix>
            <HandRaisedIcon className="h-5 w-5" />
          </ListItemPrefix>
          Raise a request
        </ListItem>
        <ListItem onClick={() => onSidebarClick('details')}>
          <ListItemPrefix>
            <ChartBarIcon className="h-5 w-5" />
          </ListItemPrefix>
          Details
        </ListItem>
        <ListItem onClick={() => onSidebarClick('profile')}>
          <ListItemPrefix>
            <UserCircleIcon className="h-5 w-5" />
          </ListItemPrefix>
          Profile
        </ListItem>
        {/* Add other ListItems here */}
      </List>
    </Card>
  );
}
